import React, { FunctionComponent, useState } from 'react';
import { ExcessDisclaimer } from 'scenes/common/components/Disclaimer';
import { ExcessStep as CommonExcessStep } from 'scenes/common/components/Steps';
import { InterstitialModal } from 'scenes/motor/components/InterstitialModal';
import { useIntersitialContext } from 'scenes/motor/context';
import {
  getAdditionalExcesses,
  getPreselectedPrice,
  getSelectedCoverType,
  getSelectedExcess,
  getStandardExcesses,
  isThirdPartySelected,
} from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';
import ExcessModal from './ExcessModal';

const ExcessStep: FunctionComponent<MotorFullPageProps> = ({
  onNext,
  onUpdateExcess,
  funnelState,
  onClickSaveQuoteModal,
}) => {
  const [value] = useIntersitialContext();
  const [showModal, setShowModal] = useState(false);
  const standardExcesses = getStandardExcesses(funnelState);
  const isThirdParty = isThirdPartySelected(funnelState);

  return (
    <>
      {value.postQuote && <InterstitialModal preQuote={false} />}
      <CommonExcessStep
        question={standardExcesses.length > 1 ? 'Choose your excess' : 'Excess'}
        helpText={
          standardExcesses.length > 1
            ? 'This quote is based on the excess selected. Select a higher excess to reduce your premium further.'
            : ''
        }
        helpLink={{
          id: 'helpLink',
          text: 'How excess works',
          ariaLabel: 'How excess works - Opens dialog',
          onClick: () => {
            setShowModal(true);
          },
        }}
        defaultStateValue={getSelectedExcess(funnelState)}
        options={standardExcesses}
        quoteDetails={funnelState.apiResponses.quoteDetails}
        coverType={getSelectedCoverType(funnelState)}
        price={getPreselectedPrice(funnelState)}
        onNext={onNext}
        onUpdateExcess={onUpdateExcess}
        onClickSaveQuoteModal={onClickSaveQuoteModal}
        disclaimer={<ExcessDisclaimer isThirdParty={isThirdParty} />}
      />
      <ExcessModal
        excesses={getAdditionalExcesses(funnelState)}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default ExcessStep;
